import { getApi, postApi } from "../api";


export const createLeadApi = (data) => postApi(`/lead/create`, data);
export const getThisWeekLeadsAdminApi = () => getApi(`/lead/this-week-admin`);
 export const getAllLeadsAdminApi = () => getApi(`/lead/admin-all-leads/category/2`);
export const getAllTxnAdminApi = () => getApi(`/txn/all-admin`);
// export const getAllLeadsAdminApi = () => getApi(`/lead/admin-all`);
